<template>
  <h3 class="font-bold lg:text-center relative xl:px-0 lg:px-20">
    <WrGradientText append-class="pt-0 leading-[1.3] text-center">
      {{ expertise?.heading }}
    </WrGradientText>
  </h3>

  <p class="xl:mt-7 leading-[1.7] md:text-lg md:text-center  max-md:px-0 max-md:text-center">
    {{ expertise?.subheading }}
  </p>

  <div
    class="grid lg:grid-cols-2 grid-cols-1 gap-5 mt-9 w-full  relative z-10"
  >
    <template v-for="card in expertise?.expertisetext">
      <div
        class="dark:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.5)]  dark:hover:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.8)] dark:bg-transparent bg-white rounded-xl hover:[box-shadow:0_.0625rem_.75rem_0_rgba(38,57,82,.2)] [box-shadow:0_.3em_.3em_-.3em_hsla(0,0%,4%,.1),_0_0_0_.1rem_hsla(0,0%,4%,.08)] transition-all duration-200 relative flex flex-col max-h-[100%]"
      >
        <NuxtImg
          :src="card?.image"
          height="247"
          width="565"
          loading="lazy"
          class="rounded-t-xl max-lg:w-full object-contain"
          v-if="card?.image"
          :alt="card?.heading"
          format="webp"
        />
        <div class="p-5">
          <h3 class="text-lg text-[var(--primary)] font-semibold">
            {{ card?.heading }}
          </h3>
          <p class="mt-3 text-sm leading-[2]">{{ card?.text }}</p>
        </div>
      </div>
    </template>
  </div>
  <div
    v-if="expertise?.textcontent"
    class="grid lg:grid-cols-2 grid-cols-1 gap-5 mt-9 w-full justify-center relative z-10"
  >
    <template v-for="card in expertise?.textcontent">
      <div
        class="dark:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.5)] dark:hover:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.8)] dark:bg-transparent bg-white rounded-xl hover:[box-shadow:0_.0625rem_.75rem_0_rgba(38,57,82,.2)] [box-shadow:0_.3em_.3em_-.3em_hsla(0,0%,4%,.1),_0_0_0_.1rem_hsla(0,0%,4%,.08)] transition-all duration-200 relative flex flex-col max-h-[100%]"
        :class="card?.image ? 'max-h-[100%]' : 'max-h-[100%]'"
      >
        <NuxtImg
          :src="card?.image"
          height="247"
          width="565"
          loading="lazy"
          class="rounded-t-xl max-lg:w-full"
          v-if="card?.image"
          :alt="card?.heading"
          format="webp"
        />
        <div class="p-5">
          <h3 class="text-lg font-semibold">
            {{ card?.heading }}
          </h3>
          <p class="mt-3 text-sm leading-[1.7]">{{ card?.text }}</p>
        </div>
      </div>
    </template>
  </div>
  <span
    class="block dark:hidden absolute -bottom-[40px] left-1/2 translate-x-[-50%] w-[1rem] h-[1rem] bg-[#ff808e] rounded-full z-10"
  ></span>
</template>

<script setup lang="ts">
import WrGradientText from '../global/WrGradientText.vue';

defineProps<{
  expertise: unknown;
}>();
</script>
